import React, { useContext } from "react";
import { Modal } from "react-bootstrap";
import { LoginContext } from "../../../../App";

const CustomModal = ({
  size,
  show,
  handleClose,
  headerContent,
  bodyContent,
  footerContent,
  backdrop = true,
  keyboard = true,
  closeVariant = 'custom'
}) => {
  const { theme } = useContext(LoginContext);
  const CloseIcon = () => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={theme === 'dark' ? 'text-white' : 'text-dark'}
    >
      <path
        d="M18 6L6 18M6 6L18 18"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );

  return (
    <Modal
      size={size?.trim() ? size : "md"}
      show={show}
      onHide={handleClose}
      backdrop={backdrop ? true : 'static'}
      keyboard={keyboard}
      centered
      data-bs-theme={theme}
    >
      <div className="position-relative">
        {closeVariant === 'custom' && (
          <button
            type="button"
            onClick={handleClose}
            className={`position-absolute rounded-circle p-2 border-0 ${theme === 'dark' ? 'bg-danger' : 'bg-white'}`}
            aria-label="Close"
            style={{
              right: '-12px',
              top: '-12px',
              zIndex: 1060,
              boxShadow: '0 2px 8px rgba(0,0,0,0.15)'
            }}
          >
            <CloseIcon />
          </button>
        )}

        <Modal.Header
          closeButton={closeVariant === 'default'}
          className={`border-1 pb-2 ${closeVariant === 'custom' ? 'pt-4' : ''}`}
        >
          <div className="w-100 text-center">
            {headerContent}
          </div>
        </Modal.Header>

        <Modal.Body className="d-flex flex-column pt-3 justify-content-center align-items-center">
          {bodyContent}
        </Modal.Body>

        <Modal.Footer className="border-0 justify-content-center pt-0">
          {footerContent}
        </Modal.Footer>
      </div>
    </Modal>
  );
};

export default CustomModal;